import { PreloadedQuery } from "react-relay";

import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { PricingPageRelayQuery } from "@/contentful/graphql/pricing-page";
import { StrategyCollectionPricingPageTemplate } from "@/templates/collections/strategy/pricing/strategy-collection-pricing-page.template.tsx";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content-gql.ts";
import { UserLocale } from "@/utils/useGeoCurrency.ts";

import { AppPricingData } from "../../../../contentful/index.tsx";

export interface StrategyCollectionPricingPageProps {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    // @ts-ignore
    queryRef?: PreloadedQuery<typeof PricingPageRelayQuery>;
}

export const StrategyCollectionPricingPage = (
    props: StrategyCollectionPricingPageProps
) => {
    const { pricingContent, queryRef } = props;

    return (
        <PricingContentContextProviderRelay
            productId="strategy-collection"
            pricingContent={pricingContent}
            // @ts-ignore
            queryRef={queryRef}
        >
            <StrategyCollectionPricingPageTemplate />
        </PricingContentContextProviderRelay>
    );
};
